import { CIDADAO_PATH } from 'components/layout/SideMenu/SideMenuItems'
import qs from 'qs'
import { useHistory, useLocation } from 'react-router'
import { CADASTRAR_IMOVEL_PATH, EDITAR_IMOVEL_PATH } from 'view/cadastro-imovel/constants-cadastroImovel'
import { ImovelUrlParams } from 'view/visualizacao-imovel/model-visualizacao-imovel'

interface QueryParams {
  callbackUrl: string
  callbackParams: string
  cadImovelUrlParams: ImovelUrlParams
}

export function useNavigateToCidadaoCallbackUrl() {
  const location = useLocation()
  const history = useHistory()

  const urlParams: QueryParams = qs.parse(location.search, {
    ignoreQueryPrefix: true,
  })

  function handleCallbackSwitch(cidadaoId?: ID) {
    /* TODO (NP) #23449: Reavaliar o Switch, além disso, alguns desses cases não funcionam, os módulos que supostamente são responsáveis
     por eles, acabam redirecionando para o valor default (ainda funciona) */
    switch (urlParams?.callbackUrl) {
      case 'registroTardio/cidadao-ausente':
        history.push(`/registroTardio?${urlParams.callbackParams}`)
        break
      case 'lista-atendimento/cidadao-ausente':
        history.push(`/lista-atendimento?${urlParams.callbackParams}`)
        break
      case 'cadastro-cidadao':
        history.push(`/lista-atendimento/atendimento/${urlParams.callbackParams}/${urlParams.callbackUrl}`)
        break
      case '/gestaoCadastros/acompanhamento-territorio':
        history.push(`${urlParams.callbackUrl}?redirect=true`)
        break
      case 'lista-atendimento/atendimento':
      case 'lista-atendimento/atendimento-vacinacao':
        history.push(`/${urlParams.callbackUrl}/${urlParams.callbackParams}`)
        break
      case EDITAR_IMOVEL_PATH: {
        const cidadaoQuery = cidadaoId ? `cidadaoId=${cidadaoId}&` : ''
        history.push(
          `${urlParams.callbackUrl}/${urlParams.cadImovelUrlParams.imovelId}?${cidadaoQuery}redirect=${urlParams.cadImovelUrlParams.redirect}`
        )
        break
      }
      case CADASTRAR_IMOVEL_PATH: {
        const cidadaoQuery = cidadaoId ? `cidadaoId=${cidadaoId}&` : ''
        history.push(
          `${urlParams.callbackUrl}?${cidadaoQuery}redirect=${urlParams.cadImovelUrlParams?.redirect}${
            urlParams.cadImovelUrlParams?.endereco ? '&endereco=true' : ''
          }`
        )
        break
      }
      case 'visualizar-escuta':
      case 'escuta-inicial':
        history.push(`/lista-atendimento/${urlParams.callbackUrl}/${urlParams.callbackParams}/cadastro-cidadao`)
        break
      default:
        if (cidadaoId && urlParams.callbackUrl) {
          history.push(`${urlParams.callbackUrl}?cidadaoId=${cidadaoId}`)
        } else if (cidadaoId && !urlParams.callbackUrl) {
          history.push(`${CIDADAO_PATH}/${cidadaoId}/informacoes` + history.location.search)
        } else {
          history.push(CIDADAO_PATH + history.location.search)
        }
        break
    }
  }

  function handleBase64Callback(cidadaoId?: ID) {
    //callback para módulos antigos (falha quando callbackUrl não é base64) - remover try/catch quando os módulos forem refeitos
    const url = atob(urlParams.callbackUrl)
    const decodedParams = atob(urlParams.callbackParams)
    const path = url === '/pec/user/registrotardiolisting/registrotardiodetail' ? 'registroTardio' : ''
    history.push(
      `/${path}?iframeUrl=${url}?${btoa(decodedParams + '&' + qs.stringify({ cidadaoCadastradoId: cidadaoId }))}`
    )
  }

  return (cidadaoId?: ID) => {
    try {
      handleBase64Callback(cidadaoId)
    } catch {
      handleCallbackSwitch(cidadaoId)
    }
  }
}
